import { Button } from "react-bootstrap";

function Boton({ text, bgColor}) {
  return (
    <Button
      type="submit"
      className="btn-accent align-self-center px-5 py-3 my-3 fw-semibold rounded-pill w-75"
    >
      {text}
    </Button>
  );
}
export default Boton;